import styles from './DialogContent.module.scss';
import React from 'react';
import { ScrollFadeContainer } from '../../ScrollFadeContainer/ScrollFadeContainer.tsx';
export function DialogContent({ children }) {
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.content,
        "data-testid": "dialog-content"
    }, /*#__PURE__*/ React.createElement(ScrollFadeContainer, {
        direction: "vertical"
    }, children));
}
